import { IAppuntamento } from 'app/model/appuntamento';
import { Component, Input } from '@angular/core';

@Component({
	selector: 'full-calendar-tooltip',
	templateUrl: 'tooltip.html'
})
export class TooltipComponent {
	@Input()
	event: IAppuntamento;

	constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/app/components/tooltip/tooltip.ts